__turbopack_context__.v({
  "blocksBackgroundColor": "PoweredByCS-module-scss-module__SpcfnW__blocksBackgroundColor",
  "blocksFontColor": "PoweredByCS-module-scss-module__SpcfnW__blocksFontColor",
  "loginButton": "PoweredByCS-module-scss-module__SpcfnW__loginButton",
  "manageButton": "PoweredByCS-module-scss-module__SpcfnW__manageButton",
  "poweredByContainer": "PoweredByCS-module-scss-module__SpcfnW__poweredByContainer",
  "secondaryNavBackgroundColor": "PoweredByCS-module-scss-module__SpcfnW__secondaryNavBackgroundColor",
  "themeBackgroundColor": "PoweredByCS-module-scss-module__SpcfnW__themeBackgroundColor",
  "themeFontColor": "PoweredByCS-module-scss-module__SpcfnW__themeFontColor",
  "themeFontFamily": "PoweredByCS-module-scss-module__SpcfnW__themeFontFamily",
});
